// full.component.ts
import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatSidenav } from '@angular/material/sidenav';
import { NavItem } from './sidebar/nav-item/nav-item';
import { Router } from '@angular/router';
import { ToastService } from 'src/app/services/toast.service';
import { ToastConfig } from 'src/app/pages/ui-components/shared/components/toast/toast.component';

const MOBILE_VIEW = 'screen and (max-width: 768px)';
const TABLET_VIEW = 'screen and (min-width: 769px) and (max-width: 1024px)';
const MONITOR_VIEW = 'screen and (min-width: 1024px)';

@Component({
  selector: 'app-full',
  templateUrl: './full.component.html',
  styleUrls: ['./full.component.scss'],
})
export class FullComponent implements OnInit {
  @ViewChild('leftsidenav')
  public sidenav: MatSidenav | any;
  isHovering = false;
  hoverTimeout: any;
  private layoutChangesSubscription = Subscription.EMPTY;
  public isMobileScreen = false;
  public isTabletScreen = false;
  public isCollapsed = false;
  private isContentWidthFixed = true;
  private isCollapsedWidthFixed = false;
  private htmlElement!: HTMLHtmlElement;

  // Toast properties
  toast = { show: false };
  toastConfig: ToastConfig = {
    type: 'success',
    title: '',
    message: '',
    duration: 3000,
    showIcon: true,
    position: 'bottom-center'
  };

  get isOver(): boolean {
    return this.isMobileScreen || this.isTabletScreen;
  }

  constructor(
    private breakpointObserver: BreakpointObserver, 
    private router: Router,
    private toastService: ToastService
  ) {
    this.htmlElement = document.querySelector('html')!;
    this.layoutChangesSubscription = this.breakpointObserver
      .observe([MOBILE_VIEW, TABLET_VIEW, MONITOR_VIEW])
      .subscribe((state) => {
        this.isMobileScreen = state.breakpoints[MOBILE_VIEW];
        this.isTabletScreen = state.breakpoints[TABLET_VIEW];
        
        if (this.isMobileScreen) {
          this.isCollapsed = true;
        }
      });

    // Subscribe to toast state changes
    this.toastService.toastState$.subscribe(state => {
      this.toast = { show: state.show };
      this.toastConfig = state.config;
      console.log('Toast state updated:', this.toast);
    });
  }

  hideToast(): void {
    this.toastService.hideToast();
  }

  onSidenavMouseEnter() {
    if (!this.isOver && this.isCollapsed) {
      if (this.hoverTimeout) {
        clearTimeout(this.hoverTimeout);
      }
      this.isHovering = true;
    }
  }
  
  onSidenavMouseLeave() {
    if (!this.isOver && this.isCollapsed) {
      this.hoverTimeout = setTimeout(() => {
        this.isHovering = false;
      }, 300);
    }
  }

  ngOnInit(): void {}

  ngOnDestroy() {
    this.layoutChangesSubscription.unsubscribe();
  }

  toggleCollapsed() {
    this.isCollapsed = !this.isCollapsed;
    this.isContentWidthFixed = false;
  }

  onSidenavClosedStart() {
    this.isContentWidthFixed = false;
  }

  onSidenavOpenedChange(isOpened: boolean) {
    this.isCollapsedWidthFixed = !this.isOver;
  }
  
  toggleSidenav() {
    this.sidenav.toggle();
  }

  onSidebarItemSelected(item: NavItem) {
    if (item.route) {
      const [path, query] = item.route.split('?');
      const queryParams: { [key: string]: string } = {};
      
      if (query) {
        const params = new URLSearchParams(query);
        params.forEach((value, key) => {
          queryParams[key] = value;
        });
      }

      this.router.navigate([path], { queryParams });
      
      if (this.isMobileScreen) {
        this.sidenav.close();
      }
    }
  }
}